// extracted by mini-css-extract-plugin
module.exports = {"top":"itemView_docList_top__1VPRS","wrapper":"itemView_docList_wrapper__1ug5e"};